// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1dXs1","alertIcon":"ConfirmModal_alertIcon___gufX"};